var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["tab-bar-view"]},[_c('div',{class:["content"]},[_c('div',{class:["section"]},[_c('tab-bar-default')],1),_c('div',{class:["section"]},[_c('tab-bar-slider')],1),_c('div',{class:["section"]},[_c('tab-bar-inline')],1),_c('div',{class:["section"]},[_c('tab-bar-slot')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }